export default __webpack_public_path__ + "static/media/checkmark.add40fe6.svg";